import { put, takeEvery, call } from "redux-saga/effects";

import * as apis from "../../network/apis/admins";
import { getStandardAdminsListResponse } from "./slice";
import { showSnackMsg } from "../../utils/Helpers";
import { ROUTES_PATHS } from "../../utils/RoutesPaths";
import { setCanShowEmptyState, setSkeletonObject } from "../Loader/slice";

export function* getStandardAdminsListSaga({ payload }) {
  try {
    yield put(getStandardAdminsListResponse({}));
    yield put(setSkeletonObject({ field: "table", value: true }));
    const response = yield call(apis.getStandardAdmins, payload);
    const meta = {
      currentPage: +response.headers["current-page"],
      count: +response.headers["total-count"],
      pages: +response.headers["total-pages"],
      totalAdmins: response.headers["total-count"],
    };
    const admins = response.data?.admins;
    yield put(
      getStandardAdminsListResponse({
        admins,
        meta,
      })
    );
    yield put(setSkeletonObject({ field: "table", value: false }));
    if (admins.length === 0) {
      yield put(setCanShowEmptyState(true));
    } else {
      yield put(setCanShowEmptyState(false));
    }
  } catch (err) {
    yield put(setSkeletonObject({ field: "table", value: false }));
    yield put(setCanShowEmptyState(true));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* addStandardAdminSaga({ payload }) {
  try {
    yield call(apis.addStandardAdmin, payload.data);
    yield showSnackMsg(payload.successMsg, "success");
    yield payload.navigate(ROUTES_PATHS.standardAdmins);
  } catch (err) {
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* sendResetPasswordEmailSaga({ payload }) {
  try {
    yield call(apis.sendResetPasswordEmail, payload.data);
    yield showSnackMsg(payload.successMsg, "success");
  } catch (err) {
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export default function* AdminsSagas() {
  yield takeEvery(
    "admins/getStandardAdminsListRequest",
    getStandardAdminsListSaga
  );
  yield takeEvery("admins/addStandardAdminRequest", addStandardAdminSaga);
  yield takeEvery("admins/sendResetPasswordEmail", sendResetPasswordEmailSaga);
}
